import React from 'react';

import { HStack } from './HStack';
import { VStack } from './VStack';

type StackProps = HStackWithDirection | VStackWithDirection;

export const Stack = React.memo((props: StackProps) => {
  const { direction = 'column', ...rest } = props;

  return direction === 'column' ? (
    <VStack {...(rest as VStackProps)} />
  ) : (
    <HStack {...(rest as HStackProps)} />
  );
});

//
// ─── TYPES ──────────────────────────────────────────────────────────────────────
//

type HStackProps = React.ComponentProps<typeof HStack>;
type VStackProps = React.ComponentProps<typeof VStack>;

type HStackWithDirection = Readonly<{
  direction?: 'row';
}> &
  HStackProps;

type VStackWithDirection = Readonly<{
  direction?: 'column';
}> &
  VStackProps;
